import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoanDashboardRoutingModule } from "./loan-dashboard-routing.module";
import { LoanDashboardComponent } from "./loan-dashboard.component";
import { SharedModule } from "src/app/shared/shared.module";
import { AadhaarKycComponent } from "./components/aadhaar-kyc/aadhaar-kyc.component";
import { PanExpiredComponent } from "./components/pan-expired/pan-expired.component";
import { ReTakeComponent } from "./components/re-take/re-take.component";

@NgModule({
    declarations: [LoanDashboardComponent, ReTakeComponent, AadhaarKycComponent, PanExpiredComponent],
    imports: [CommonModule, LoanDashboardRoutingModule, SharedModule],
})
export class LoanDashboardModule {}
